import { withInstall } from '@tw-element/utils'
import Dialog from './src/dialog.vue'

export const TwDialog = withInstall(Dialog)
export default TwDialog

export * from './src/use-dialog'
export * from './src/dialog'
